import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { CampaignMilestone } from '../../../shared/interfaces';

@Component({
  selector: 'mtm-horizontal-multiline-timeline',
  templateUrl: './horizontal-multiline-timeline.component.html',
  styleUrl: './horizontal-multiline-timeline.component.scss',
  standalone: false,
})
export class HorizontalMultlineTimelineComponent {
  @Input() timeline: CampaignMilestone[];
  @Input() isDownload: boolean = false;
  @Output() milestoneClicked = new EventEmitter<CampaignMilestone>();
  @Input() canEdit: boolean = true;

  gateMilestoneNames = [
    'GO 360 KICK OFF',
    'GO 360 STRATEGIC NOTE',
    'GO KEY VISUALS',
    'GO PRIORITY PAID MEDIA ASSETS',
    'GO E-RETAIL PDP ASSETS',
    'GO BRIEF MAGELLAN',
    'MARKETING BOOK',
  ];

  toggleCategory(category) {
    if (category.hideCategory === undefined) {
      category.hideCategory = false;
    }
    category.hideCategory = !category.hideCategory;
  }

  onMilestoneClick(milestone: CampaignMilestone) {
    this.milestoneClicked.emit(milestone);
  }

  getFormattedDate(dateString: string) {
    const date = new Date(dateString);
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }
}
